//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnDestroy,
  signal,
} from "@angular/core";

//rxjs imports
import { map, Subject, switchMap, takeUntil, timer } from "rxjs";

//local imports
import {
  BreadcrumbItemToggleMessage,
  IBreadcrumbItemModel,
  Messenger,
} from "@app/shared";

@Component({
    selector: "carousel-item",
    templateUrl: "./carousel-item.component.html",
    styleUrl: "./carousel-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CarouselItemComponent<T> implements OnDestroy {
  public data = input.required<T>();
  public isExpanded = signal(false);

  private readonly destroying$ = new Subject<void>();
  private hoverIn$ = new Subject<void>();
  private hoverOut$ = new Subject<void>();

  constructor(private messenger: Messenger) {
    this.hoverIn$
    .pipe(
      switchMap(() =>
        timer(600).pipe(
          takeUntil(this.hoverOut$),
          map(() => true)
        )
      ),
      takeUntil(this.destroying$) 
    )
    .subscribe(val => this.isExpanded.set(val));

  this.hoverOut$
    .pipe(takeUntil(this.destroying$))
    .subscribe(() => this.isExpanded.set(false));
  }


  public onHover(state: 'in' | 'out') {
    state === 'in' ? this.hoverIn$.next() : this.hoverOut$.next();
  }

  public addToBreadCrumb(item: IBreadcrumbItemModel) {
    this.messenger.send(new BreadcrumbItemToggleMessage(item));
  }

  ngOnDestroy() {
    this.destroying$.next(undefined);
    this.destroying$.complete();
    
    this.hoverIn$.complete();
    this.hoverOut$.complete();
  }
}
